import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import SEOTracker from "@/components/SEOTracker";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Solutions from "@/pages/Solutions";
import Industries from "@/pages/Industries";
import Clients from "@/pages/Clients";
import CaseStudy from "@/pages/CaseStudy";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Demo from "@/pages/Demo";
import STB from "@/pages/STB";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/I18nProvider";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <SEOTracker />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/set-top-box" element={<STB />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:slug" element={<CaseStudy />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/demo" element={<Demo />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
